import React, { useState, useEffect, useRef } from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useShowListEditBoxContext,
  useActiveListContext,
} from '../../../context';
import { COLORS } from '../../../constants';
import { Float } from '../../float';
import { timestamp } from '../../../lib';
import { resizeOnInput } from '../../../helpers';
import { Core } from '../..';
import { ColorChoice } from './color-choice';
import { ColorContainer } from './styles';

export const EditList = () => {
  const textareaRef = useRef();
  const { firebase } = useFirebaseContext();
  const { lists, setLists, setMaxModifiedAt } = useAllInOneContext();
  const {
    showListEditBox,
    setShowListEditBox,
    targetEditList,
    setTargetEditList,
  } = useShowListEditBoxContext();
  const {
    activeList,
    setActiveList,
    themeColor,
    themeColor_L2,
  } = useActiveListContext();
  const [invalid, setInvalid] = useState(false);
  const [progress, setProgress] = useState(0);
  const [tempListName, setTempListName] = useState('');
  const [listColor, setListColor] = useState(0);
  const [forceCloseNotYet, setForceCloseNotYet] = useState(true);
  const [isInEdit, setIsInEdit] = useState(false);

  const resetAll = () => {
    setTempListName('');
    setListColor(0);
    setForceCloseNotYet(true);
  };

  useEffect(() => {
    if (!forceCloseNotYet) {
      setShowListEditBox(false);
      setTargetEditList();
      resetAll();
    }
  }, [forceCloseNotYet]);

  useEffect(() => {
    if (tempListName != '') setInvalid(false);
    else setInvalid(true);
  }, [tempListName]);

  useEffect(() => {
    if (targetEditList) {
      setTempListName(targetEditList.name);
      setListColor(targetEditList.color);
    }
  }, [targetEditList]);

  useEffect(() => {
    if (
      targetEditList &&
      showListEditBox &&
      textareaRef &&
      textareaRef.current
    ) {
      textareaRef.current.value = targetEditList.name;

      resizeOnInput(textareaRef.current);
    }
  }, [targetEditList, showListEditBox]);

  const editList = () => {
    if (targetEditList) {
      const docID = targetEditList.docID;

      const tempModifiedAt = timestamp.now().toMillis();
      setProgress(20);

      firebase
        .firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid)
        .collection('lists')
        .doc(docID)
        .update({
          name: tempListName,
          color: listColor,
          modifiedAt: tempModifiedAt,
        })
        .then(() => {
          setProgress(40);

          const temp = lists;
          const index = lists.findIndex((item) => item.docID == docID);
          setProgress(60);

          temp[index].name = tempListName;
          temp[index].color = listColor;
          temp[index].modifiedAt = tempModifiedAt;

          setLists();
          setLists(temp);
          setProgress(80);
 
          setActiveList();
          setActiveList(activeList);
          setProgress(100);

          setMaxModifiedAt(tempModifiedAt);

          setIsInEdit(false);

          setShowListEditBox(false);
          setTargetEditList();

          resetAll();
        });
    }
  };

  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={isInEdit}
      >
        Saving the Changes...
      </Core.ForceAlert>
      <div>
        <Float.Card
          disabled={invalid}
          color={themeColor}
          color_L2={themeColor_L2}
          showBox={targetEditList && showListEditBox}
          setShowBox={setForceCloseNotYet}
        >
          <Float.CardChild >
            <div className='title'>List Details</div>
            <div className='block' style={{ padding: '4px' }}>
              <Core.TextArea
                forwardedRef={textareaRef}
                value={tempListName}
                onChange={(e) => {
                  resizeOnInput(e.target);
                  setTempListName(e.target.value);
                }}
                type='text'
                placeholder='List Name'
                rows='1'
              ></Core.TextArea>
            </div>
            <ColorContainer
              className='block'
              style={{
                display: 'grid',
                placeItems: 'center',
                gridTemplateColumns: 'repeat(auto-fit, minmax(25px, 1fr))',
                gridGap: '10px',
                padding: '20px',
              }}
            >
              {COLORS.map((color, index) => (
                <ColorChoice
                  key={index}
                  color={color}
                  index={index}
                  listColor={listColor}
                  setListColor={setListColor}
                />
              ))}
            </ColorContainer>
          </Float.CardChild>

          <div>
            <div
              type='button'
              onClick={() => {
                setIsInEdit(true);
                editList();
              }}
            >
              Done
            </div>

            <div
              onClick={() => {
                setShowListEditBox(false);
                setTargetEditList();
                resetAll();
              }}
            >
              Cancel
            </div>
          </div>
        </Float.Card>
      </div>
    </>
  );
};
